import { getFeedback } from '@/api/interviews';
import { useApiQuery } from '@/hooks/api';
import { REFERENCE_STALE_TIME } from '@/hooks/api/defaults';
import { queryKeys } from '@/shared/lib/queryKeys';

import type { FeedbackFormValues } from '@/components/form/FeedbackForm';

export function useFeedbackQuery(
  interviewId: string | undefined,
  feedbackId: string | undefined,
  options?: { enabled?: boolean },
) {
  const { enabled = true } = options ?? {};

  return useApiQuery<Partial<FeedbackFormValues> | null | undefined>({
    queryKey: queryKeys.interviews.feedback(
      interviewId ?? '',
      feedbackId ?? '',
    ),
    queryFn: () =>
      getFeedback(interviewId!, feedbackId!) ?? Promise.resolve(undefined),
    enabled: enabled && Boolean(interviewId && feedbackId),
    staleTime: REFERENCE_STALE_TIME,
  });
}
